<script>
export default {
  name: 'Modal',

  props: {
    small: {
      required: false,
      type: Boolean,
      default: false
    },
    large: {
      required: false,
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showModal: false,
      windowClass: 'inline-block align-bottom sm:align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transition-all sm:my-8'
    };
  },

  methods: {
    open(event) {
      this.showModal = true;
      this.$emit('open');
    },
    close(event) {
      this.showModal = false;
      this.$emit('close');
    },
    cancel(event) {
      this.showModal = false;
    }
  }
};

</script>

<template>
  <div>
    <div class="fixed z-100 inset-0 overflow-y-auto" v-show="showModal">
      <div>
        <div class="fixed inset-0 bg-black opacity-75"></div>
      </div>
      <div class="fixed z-1000 inset-0 flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;

        <div :class="[windowClass, small ? 'max-w-screen-sm ' : 'max-w-screen-lg ', large ? 'lg:w-full md:w-3/4' : '']" role="dialog" aria-modal="true"
             aria-labelledby="modal-headline">
          <div class="sm:flex sm:items-start">
            <slot></slot>
          </div>
          <div class="bg-secondary px-2 pb-3 pt-1 sm:flex sm:flex-row-reverse">
            <slot name="footer" :close="close" :cancel="cancel"></slot>
          </div>
        </div>
      </div>
    </div>

    <slot name="toggle" :open="open"></slot>
  </div>
</template>
